import React from 'react';
import { Button } from '@bringg/react-components';

interface TooltipUnassignButtonProps {
	color: string;
	text: string;
	onClick: () => void;
}

const TooltipUnassignButton: React.FC<TooltipUnassignButtonProps> = ({ color, text, onClick }) => {
	return (
		<div className="task-tooltip-body-content-row">
			<Button
				className="tooltip-item-unassign-button"
				style={{ '--color': color } as React.CSSProperties}
				onClick={onClick}
				type="link"
				data-test-id="tooltip-item-unassign-button"
			>
				{text}
			</Button>
		</div>
	);
};

export default TooltipUnassignButton;
